<template>
  <!-- suppress TypeScriptValidateTypes -->
  <DynamicResource
    v-if="status !== 'pending'"
    :resource="{
      mediaType: reference?.original.mediaType ?? 'image/png',
      src: src,
      alt: translate(reference?.locales, locale)?.description,
      options: props.options,
    }"
  />
</template>

<script setup lang="ts">
import { type FileReference, translate } from '~/composables/charon'

const props = defineProps<{
  fileId: string | null
  options?: any
}>()

const config = useRuntimeConfig()
const { charon } = useCharon()
const { locale } = useI18n()

const { status, data: reference } = useAsyncData(
  `file-reference-${props.fileId ?? 'placeholder'}`,
  () => props.fileId ? charon<FileReference>(`/file-references/${props.fileId}`) : Promise.resolve(null),
  {
    lazy: true,
    server: true,
  },
)

const src = computed(() => {
  if (reference.value == null) {
    return 'images/component/charonFile/news_placeholder.png'
  }
  if (reference?.value?.original.mediaType?.startsWith('image')) {
    return `/charon/${reference.value?.id}`
  }
  return `${config.public.charonUrl}/file-references/file/${reference.value?.id}`
})
</script>
